import { SvgIconProps, Typography } from '@mui/material'
import { useHistoryCustomBack, useNavigate } from 'weblite-router'
// import { ApproveIcon } from '$common/icons'
import { t } from 'i18next'
import {
  PackageVariantClosedCheckIcon,
  PagePreviousOutlineIcon,
  PuzzleOutlineIcon,
} from '@weblite/icons'
import { FC, useCallback } from 'react'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitle } from '$common/app-bar/app-bar-back-title'

function PrivacyItem({
  description,
  Icon,
  title,
}: {
  Icon?: FC<SvgIconProps>
  title?: string
  description: string
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {title && (
        <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
          {Icon && (
            <Icon
              sx={{ width: '24px', height: '24px', color: 'secondary700' }}
            />
          )}
          <Typography variant="subtitle1" color="neutral1000">
            {title}
          </Typography>
        </div>
      )}
      <Typography variant="paragraph2" color="neutral1000">
        {description}
      </Typography>
    </div>
  )
}
const PRIVACY_ITEMS = [
  {
    description: t('privacyPolicy.description0'),
  },
  {
    title: t('privacyPolicy.title1'),
    description: t('privacyPolicy.description1'),
    icon: PackageVariantClosedCheckIcon,
  },
  {
    title: t('privacyPolicy.title2'),
    description: t('privacyPolicy.description2'),
    icon: PuzzleOutlineIcon,
  },
  {
    title: t('privacyPolicy.title3'),
    description: t('privacyPolicy.description3'),
    icon: PagePreviousOutlineIcon,
  },
]

// style={{
//   overflow: 'auto',
//       background: 'white',
//       display: 'flex',
//       flexDirection: 'column',
//       height: '100%',
// }}
interface Props {
  onBack?: () => void
}
export function PrivacyPolicy({ onBack }: Props) {
  const navigate = useNavigate()

  const handleBack = useCallback(() => {
    if (onBack) onBack()
    else navigate(-1)
  }, [onBack])

  useHistoryCustomBack(() => {
    handleBack()
  }, [handleBack])

  return (
    <PageWithAppBar
      appBar={
        <AppBarBackTitle title={t('privacyPolicy.title')} onBack={handleBack} />
      }
      rootSx={{}}
      bodySx={{
        backgroundColor: 'neutral000',
        padding: '16px',
        gap: '24px',
      }}
    >
      {PRIVACY_ITEMS.map(({ title, description, icon }) => (
        <PrivacyItem Icon={icon} title={title} description={description} />
      ))}
    </PageWithAppBar>
  )
}
